import { isEmpty } from "lodash";
import React, { useEffect, useMemo, useRef } from "react";
import { connect } from "react-redux";
import OpenBetsContent from "./components/OpenBetsContent/OpenBetsContent";
import OpenBetsEmptyList from "./components/OpenBetsEmptyList/OpenBetsEmptyList";
import OpenBetsHeader from "./components/OpenBetsHeader/OpenBetsHeader";

import { ReportBetMobileType } from "app/types/reportType";
import { PollingIntervals } from "app/utils/const";

type Props = {
  isReportListLoading?: boolean;
  reportList?: ReportBetMobileType[];
  totalElements?: number;
  fetchOpenBets: (payload?: PayloadType) => void;
};

type PayloadType = {
  size?: number;
  page?: number;
  betType?: string;
};

const DEFAULT_PAGE_SIZE = 15;

const OpenBetsList: React.FC<Props> = ({
  isReportListLoading,
  reportList,
  totalElements,
  fetchOpenBets,
}) => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    fetchOpenBets();

    intervalRef.current = setInterval(() => {
      fetchOpenBets();
    }, PollingIntervals.OPEN_BETS_PANEL);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [fetchOpenBets]);

  const shouldShowEmptyList = useMemo(
    () => isEmpty(reportList) && !isReportListLoading,
    [reportList, isReportListLoading]
  );
  const shouldShowList = !isReportListLoading && !isEmpty(reportList);

  return (
    <div className="bet-drawer__content">
      <div className="manage-bets-layout open-bets">
        <OpenBetsHeader numberOfReports={totalElements || 0} />
        {shouldShowEmptyList && <OpenBetsEmptyList />}
        {shouldShowList && (
          <OpenBetsContent
            reportList={reportList!}
            isReportListLoading={Boolean(isReportListLoading)}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  isReportListLoading: state.openBetsListModel.isReportListLoading,
  reportList: state.openBetsListModel.openBetsPanelList,
  totalPages: state.openBetsListModel.totalPages,
  totalElements: state.openBetsListModel.totalElements,
});

const defaultPayload: PayloadType = {
  size: DEFAULT_PAGE_SIZE,
  page: 0,
};

const mapDispatchToProps = dispatch => ({
  fetchOpenBets: (payload?: PayloadType) => {
    dispatch.openBetsListModel.loadOpenBetsPanelList({
      ...defaultPayload,
      ...payload,
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(OpenBetsList)) as React.FC<Omit<Props, "fetchOpenBets">>;
